import {Component, EventEmitter, Input, Output,OnChanges} from '@angular/core';
import * as _ from 'underscore';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {

    @Input() count: number;
    @Input() perPage: number;
    @Input() limit: number = 10;

    @Output() goPage = new EventEmitter<number>();

    currentPage: number = 1;

    constructor() { }

    ngOnChanges(){
        this.onPage(1)
    }

    onPage(n: number): void {
        this.currentPage = n;
        this.goPage.emit(n);
    }

    totalPages(): number {
        return Math.ceil(this.count / this.perPage) || 0;
    }

    getPages(): Array<number> {
        const tp = this.totalPages();
        if(tp < this.limit){
            return _.range(this.currentPage, tp + 1);
        }

        return (this.currentPage <= tp && this.currentPage >= tp - this.limit)
            ? _.range( (tp - this.limit), tp + 1)
            : _.range(this.currentPage, (this.currentPage + this.limit))
        ;
    }

    getLastOfPages(): number {
        const max =  _.max(this.getPages());
        return (max >= this.totalPages()) ? max : max + 1;
    }

    getStart(): number {
        return (this.currentPage == 1) ? 0 : (this.currentPage - 1) * this.perPage;
    }

    getEnd(): number {
        return (this.currentPage == 1) ? this.perPage : (this.currentPage * this.perPage);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/pagination/pagination.component.ts